import AutomaticallyAddFilesToDr from './AutomaticallyAddFilesToDr.component';

export default AutomaticallyAddFilesToDr;